import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

export const TelegramButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Cache hero height to avoid repeated reads
    let heroHeight = window.innerHeight;
    let ticking = false;
    
    const handleResize = () => {
      requestAnimationFrame(() => {
        heroHeight = window.innerHeight;
      });
    };

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      
      requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        // Show button when scrolled past hero section
        setIsVisible(scrollY > heroHeight * 0.9);
        ticking = false;
      });
    };

    window.addEventListener("resize", handleResize, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <a
      href="https://t.me/mng_propaganda"
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "fixed bottom-4 right-4 z-50 flex items-center gap-2 px-3 py-2 rounded-full",
        "transition-all duration-500 ease-out",
        "md:bottom-8 md:right-8 md:px-6 md:py-3.5 md:gap-3",
        isVisible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4 pointer-events-none"
      )}
      style={{
        background: "linear-gradient(135deg, rgba(45, 45, 50, 0.95) 0%, rgba(60, 60, 65, 0.9) 100%)",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.08)",
        backdropFilter: "blur(10px)",
      }}
    >
      {/* Telegram Icon */}
      <svg
        className="w-4 h-4 md:w-6 md:h-6 text-white"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
      </svg>
      
      {/* Text */}
      <span className="text-white text-[12px] md:text-base font-medium whitespace-nowrap">
        Связаться
      </span>
    </a>
  );
};
